module.exports = __webpack_public_path__ + "static/media/big-lucky-green-bg-gold-white-400x240.64ed482a.png";